import { useEffect, useState } from 'react';
import { useDispatch, connect } from 'react-redux';
import Modal from '../../../components/common/modal';
import AlertBox from '../../../components/route-leaving-prompt/alert-box';
import { updateListenerDetailsRequest } from '../listeners-redux/actions';
import { paramsToObjects } from '../../../components/common/create-params';

type props = {
  tiersList: any;
  listenerDetails: any;
};

const TierModal: React.FunctionComponent<props> = ({ tiersList, listenerDetails }): JSX.Element => {
  const dispatch = useDispatch();
  const [selectedId, setselectedId] = useState(0);
  const params = paramsToObjects() || {};
  const listenerId = params['listenerRoleId'];
  const [modal, setmodal] = useState(false);
  const [alertModal, setalertModal] = useState(false);
  const userId = params['listenerId'];

  const [enableSaveOption, setenableSaveOption] = useState(false);

  const onSelected = (e: any) => {
    const val = e.currentTarget.value;
    setselectedId(val);
    setenableSaveOption(true);
  };

  useEffect(() => {
    if (listenerDetails) {
      setDefaultOptions();
    }
  }, [listenerDetails]);

  const setDefaultOptions = () => {
    setselectedId(listenerDetails?.id);
    setenableSaveOption(false);
  };

  const handleSave = () => {
    setmodal(false);
    setalertModal(false);
    const payload = {
      id: userId,
      listenerId,
      payload: {
        listener_role: {
          tier_id: +selectedId,
        },
      },
    };
    dispatch(updateListenerDetailsRequest(payload));
  };

  return (
    <>
      <div className="flex h-20 w-full items-center justify-between">
        <div>
          <p className="text-md text-gray-dark font-bold"> Peer Details </p>
          <div className="flex flex-wrap items-center gap-2">
            <p>{listenerDetails?.name}</p>
            {listenerDetails?.content_optional && (
              <span
                className="stacked-bar-green-primary rounded-md px-3 py-0.5 text-xs font-bold text-white"
                data-testid="content-optional-tier-badge"
                title="Experiences are waived because this peer's tier has Content Optional enabled."
              >
                Content optional
              </span>
            )}
          </div>
        </div>
        <div>
          <button
            onClick={() => {
              setmodal(true);
            }}
            className="bg-blue-primary h-10 w-28 rounded-sm px-2 text-center text-sm text-white"
          >
            Change Tier
          </button>
        </div>
      </div>
      <Modal
        isModel={modal}
        InnerComponent={
          <div className="inline-block transform overflow-hidden rounded-lg bg-white text-left align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-4xl sm:align-middle">
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
              <div className="px-7">
                <p className="blue-primary py-1 text-2xl font-normal">Current Tier</p>

                <div className="flex justify-between">
                  <div>
                    <p className="text-blue-primary py-1 text-lg font-normal">Display Name</p>
                    <p className="text-gray-dark py-1 text-lg font-normal">{listenerDetails?.name} </p>
                  </div>
                  <div>
                    <p className="text-blue-primary py-1 text-lg font-normal">Experience Max Payouts</p>
                    <p className="text-gray-dark py-1 text-lg font-normal">{listenerDetails?.max_experience_payouts}</p>
                  </div>
                  <div>
                    <p className="text-blue-primary py-1 text-lg font-normal">Experience Approvals</p>
                    <p className="text-gray-dark py-1 text-lg font-normal">
                      ${listenerDetails?.experience_bonus / 100 || 0}
                    </p>
                  </div>
                </div>
                <div className="flex">
                  <div className="-mr-4 w-1/3">
                    <p className="text-blue-primary py-1 text-lg font-normal">Experience Listens</p>
                    <p className="text-gray-dark py-1 text-lg font-normal">
                      ${listenerDetails?.experience_listen_rate / 100 || 0}
                    </p>
                  </div>
                </div>
                <div className="text-gray-dark sticky mb-2 grid h-12 w-full grid-cols-12 items-center border-b-2 border-black text-left font-bold">
                  <div className="col-span-3 font-bold">Name</div>
                  <div className="col-span-2"> Experience Approvals </div>
                  <div className="col-span-2">Experience Listens </div>
                  <div className="col-span-2"> Experience Max Payouts </div>
                </div>
                <div className="text-gray-dark sticky mb-2 grid h-64 w-full grid-cols-12 items-center gap-y-3 overflow-y-scroll text-left font-bold">
                  {tiersList?.length > 0 &&
                    tiersList?.map((tier: any) => (
                      <>
                        <div className="col-span-3 font-bold">{tier.name}</div>
                        <div className="col-span-2"> ${tier.experience_bonus / 100 || 0} </div>
                        <div className="col-span-2">${tier.experience_listen_rate / 100 || 0} </div>
                        <div className="col-span-2"> {tier.max_experience_payouts} </div>
                        <div className="col-span-2">
                          <input
                            id={tier.id}
                            type="radio"
                            name="radio"
                            value={tier.id}
                            className="hidden"
                            onChange={onSelected}
                            checked={tier.id === +selectedId}
                          />
                          <label htmlFor={tier.id} className="flex cursor-pointer items-center">
                            <span className="border-grey mr-1 inline-block h-4 w-4 rounded-full border"></span>
                          </label>
                        </div>
                      </>
                    ))}
                </div>
              </div>
              <div className="flex justify-end">
                <div>
                  <button
                    className={
                      'h-8 w-16 rounded-sm px-2 text-center text-sm text-white ' +
                      (enableSaveOption ? 'bg-blue-primary' : 'bg-gray-200')
                    }
                    onClick={handleSave}
                  >
                    Save
                  </button>
                  <button
                    className="bg-blue-primary ml-4 h-8 w-16 rounded-sm px-2 text-center text-sm text-white"
                    onClick={() => {
                      if (enableSaveOption) {
                        setalertModal(true);
                      } else {
                        setmodal(false);
                      }
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
            <AlertBox
              visible={alertModal}
              handlePrompt={() => {
                setDefaultOptions();
                setmodal(false);
                setalertModal(false);
              }}
              handleContinueSave={handleSave}
              closeModal={() => {
                setalertModal(false);
              }}
              confirmButtonText={'Discard Changes'}
              titleText={'Alert'}
              contentText={
                'You have unsaved changes.  If you leave this screen without saving, your changes will be lost.'
              }
              confirmSaveButtonText={'Save Changes'}
              cancelButtonText={'Cancel'}
            />
          </div>
        }
      />
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    tiersList: state.tiers.TiersList?.data || null,
    listenerDetails: state.Listeners?.listenersDetails?.data?.listener_role?.tier || null,
  };
};

export default connect(mapStateToProps)(TierModal);
